import React, { useMemo } from "react";
import { useSearchParams, Link } from "react-router-dom";
import packages from "../packages";
import "../assets/styles/ProductGallery.css"; // reuse ปุ่ม/ตารางเดิม

export default function CompareView() {
  const [params] = useSearchParams();
  const group = params.get("group") || "—";
  const ids = (params.get("ids") || "").split(",").filter(Boolean);

  const chosen = useMemo(() => {
    const map = new Map(packages.map(p => [p.id, p]));
    return ids.map(id => map.get(id)).filter(Boolean);
  }, [ids]);

  return (
    <section className="pg-wrap">
      <header className="pg-toolbar" style={{marginBottom: 8}}>
        <div className="pg-title">
          <h1>🔍 เปรียบเทียบแพ็กเกจ</h1>
          <p className="pg-sub">กลุ่ม: <strong>{group}</strong> • {chosen.length} รายการ</p>
        </div>
        <div>
          <Link className="pg-btn" to="/">← กลับหน้าแพ็กเกจ</Link>
        </div>
      </header>

      {!chosen.length ? (
        <div className="pg-empty">ยังไม่ได้เลือกแพ็กเกจ</div>
      ) : (
        <div className="pg-compare-modal" style={{position:"static", inset:"auto", background:"transparent", backdropFilter:"none", display:"block"}}>
          <div className="pg-compare-head" style={{position:"static", transform:"none", color:"#0f172a", display:"flex", justifyContent:"space-between", margin:"0 0 8px"}}>
            <div />
          </div>

          <table className="pg-compare-table" style={{minWidth:"100%"}}>
            <thead>
              <tr>
                <th>หัวข้อ</th>
                {chosen.map(p => <th key={p.id}>{p.nameTH || p.id}</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>บริษัท</td>
                {chosen.map(p => <td key={p.id}>{p.company}</td>)}
              </tr>
              <tr>
                <td>คำอธิบาย</td>
                {chosen.map(p => <td key={p.id}>{p.description}</td>)}
              </tr>
              <tr>
                <td>หมวด</td>
                {chosen.map(p => <td key={p.id}>{(p.categories||[]).join(", ")}</td>)}
              </tr>
              <tr>
                <td>สถานะ</td>
                {chosen.map(p => <td key={p.id}>{p.active ? "✅ เปิดขาย" : "❌ ปิด"}</td>)}
              </tr>
              {/* เพิ่มแถวเฉพาะกลุ่มในอนาคต เช่น factory/motor_truck ฯลฯ */}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
